import { DateTime } from "luxon";
import eventBus from "@/Helpers/eventBus";

export function getDeviceNavigationAppUrl(location) {
    let lat = null;
    let lon = null;
    if (location.hasOwnProperty("coordinates")) {
        lat = location.coordinates[1];
        lon = location.coordinates[0];
    } else {
        lat = location[1];
        lon = location[0];
    }

    // for SSR
    if (typeof navigator !== "undefined") {
        // iOS
        if (
            navigator.platform.indexOf("iPhone") != -1 ||
            navigator.platform.indexOf("iPod") != -1 ||
            navigator.platform.indexOf("iPad") != -1
        ) {
            return "http://maps.apple.com/?daddr=" + lat + "," + lon + "&dirflg=d";
        }

        // If its a phone
        if (mobileAndTabletCheck()) {
            return "geo:" + lat + "," + lon + "?q=" + lat + "," + lon;
        }
    }

    // Everything else
    return "https://www.google.com/maps/dir/?api=1&destination=" + lat + "," + lon;
}

// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
export function mobileAndTabletCheck() {
    let check = false;
    (function (a) {
        if (
            /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
                a,
            ) ||
            /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
                a.substr(0, 4),
            )
        )
            check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
}

export function toLocalISOString(datetime_utc) {
    // console.log(datetime_utc);
    if (!datetime_utc) {
        return "";
    }
    const date = new Date(datetime_utc);

    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");

    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");

    // console.log(
    //     year + "-" + month + "-" + day + "T" + hours + ":" + minutes
    // );
    return year + "-" + month + "-" + day + "T" + hours + ":" + minutes;
}

export function toEventLocalISOString(datetime_utc, timezone) {
    return DateTime.fromISO(datetime_utc).setZone(timezone).toFormat("y-LL-dd'T'HH:mm");
}

export function round(number, roundingPrecision = 0) {
    // return Math.round((number + Number.EPSILON) * 100) / 100;
    number = parseFloat(number);
    const pow = Math.pow(10, roundingPrecision);
    const result = Math.round((number + Number.EPSILON) * pow) / pow;
    return isNaN(result) ? 0 : result;
}

export function convertMilesToKm(miles) {
    return miles * 1.609344;
}

export function convertKmToMiles(km) {
    return km * 0.62137119;
}

export function convertKmAsPerTrackUnits(km, trackUnits, roundingPrecision = 2) {
    if (trackUnits !== "metric" && trackUnits !== "statute") {
        console.error("convertKmAsPerTrackUnits unknown trackUnits:", trackUnits);
        return;
    }
    if (trackUnits === "metric") {
        return round(km, roundingPrecision);
    } else {
        return round(convertKmToMiles(km), roundingPrecision);
    }
}

export function formatUnitsHuman(trackUnits) {
    if (trackUnits !== "metric" && trackUnits !== "statute") {
        console.error("formatUnitsHuman unknown trackUnits:", trackUnits);
        return;
    }
    return trackUnits === "metric" ? "km" : "miles";
}

export function formatSpeedUnitsHuman(trackUnits) {
    if (trackUnits !== "metric" && trackUnits !== "statute") {
        console.error("formatSpeedUnitsHuman unknown trackUnits:", trackUnits);
        return;
    }
    return trackUnits === "metric" ? "km/h" : "mph";
}

export function formatTrackDistanceHuman(track, roundingPrecision = 0) {
    if (!track.hasOwnProperty("latestVersion")) {
        console.error("formatTrackDistanceHuman: missing track.latestVersion");
        return;
    }
    const distance = convertKmAsPerTrackUnits(
        track.latestVersion.distance / 1000,
        track.units,
        roundingPrecision,
    );
    const distanceUnits = formatUnitsHuman(track.units);
    return `${distance} ${distanceUnits}`;
}

export function formatTrackSpeedLimitHuman(track) {
    if (!track.hasOwnProperty("latestVersion")) {
        console.error("formatTrackSpeedLimitHuman: missing track.latestVersion");
        return;
    }

    const distance = convertKmAsPerTrackUnits(track.latestVersion.speed_limit, track.units, 0);
    const speedUnits = formatSpeedUnitsHuman(track.units);
    return `${distance} ${speedUnits}`;
}

export function formatTrackNavigateBy(navigate_by) {
    if (navigate_by === "rb") {
        return "Roadbook";
    }
    if (navigate_by === "gpx") {
        return "GPX";
    }

    return "";
}

let decoder;

export function entityDecoder(html) {
    if (typeof window === "undefined") {
        // do not run in SSR
        return;
    }
    decoder = decoder || document.createElement("div");
    decoder.innerHTML = html;
    return decoder.textContent;
}

export function isObject(item) {
    return item && typeof item === "object" && !Array.isArray(item);
}

export function deepMerge(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                deepMerge(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return deepMerge(target, ...sources);
}

export function getCurrencySymbol(currency) {
    switch (currency) {
        case "EUR":
            return "€";
        case "USD":
            return "$";
        case "GBP":
            return "£";
    }

    return "€";
}

export function getCurrencyExchanged(toCurrency, amount, exchangeRates) {
    return amount * exchangeRates[toCurrency];
}

export function linkify(content) {
    if (typeof window === "undefined") {
        // do not run in SSR
        return;
    }

    const regex = /(https?:\/\/([^\s,]*))/gi;

    return content.replace(regex, '<a href="$1" target="_blank">$2</a>');
}

export function printElement(id) {
    // Select the element you want to highlight (e.g., an element with id "myElement")
    const element = document.getElementById(id);

    // Clear the entire webpage
    document.body.innerHTML = "";

    // Append the selected element to the cleared body
    document.body.appendChild(element);

    // Style the element to make it prominent
    element.style.display = "block";
    element.style.margin = "auto";
    element.style.fontSize = "2rem"; // Adjust the size as needed
    element.style.padding = "20px";
    element.style.backgroundColor = "white";

    window.print();
    //
    location.reload();
}

export function copyToClipboard(text) {
    navigator.clipboard
        .writeText(text)
        .then(() => {
            console.log("Copied to clipboard: ", text);
            eventBus.$emit("showToast", {
                message: "Copied to clipboard: " + text,
            });
        })
        .catch((err) => {
            console.error("Failed to copy: ", err);
            alert("Failed to copy: ", err);
        });
}
